import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import { App } from './App'

if (import.meta.env.DEV) {
  import('@locator/runtime').then(({ default: setupLocatorUI }) => setupLocatorUI())
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
)
